(function () {
  "use strict";

  const freeFreightPrice = 1500;
  const cartForm = document.getElementById(
    "addToCartForm_" + shopifyProduct.id
  );
  const addToCartUrl = document.location.origin + "/cart/add.js";
  const updateCartItemUrl = document.location.origin + "/cart/update.js";
  const headerCartItemsContainer = document.getElementById("header-cart-items");
  const addToCartButton = document.getElementById("AddToCart");
  const headerCartItemsCountElement = document.getElementById("cartItemsCount");
  const headerCartHeaderItemsCountelement = document.getElementById(
    "cart-header-item-count"
  );
  const drawerCartItemsCountElement = document.getElementById(
    "drawerCartItemsCount"
  );
  const addedToCartMessageElement = document.getElementById(
    "added-to-cart-message"
  );
  const hasFreeShippingElement = document.getElementById("has-free-shipping");

  let cartSubtotal = 0;
  let freeFreight = false;

  cartForm.addEventListener("submit", async (ev) => {
    ev.preventDefault();

    addToCartButton.setAttribute("disabled", true);

    try {
      let res = await fetch(addToCartUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(
          Object.fromEntries(new FormData(ev.currentTarget).entries())
        ),
      });

      // Handle error
      if (!res.ok) {
        let error = await res.text();
        // Show updated cart for a few seconds
        addedToCartMessageElement.classList.add("error");
        setTimeout(() => {
          // Hide updated cart again
          addedToCartMessageElement.classList.remove("error");
        }, 5000);
      }

      // Handle success
      let productAdded = await res.json();

      // Update cart
      updateCart(jsShoppingCart, productAdded);

      // Redraw cart
      redrawCart(jsShoppingCart);

      // Update cart items count in header
      headerCartItemsCountElement.innerHTML = jsShoppingCart.item_count;

      // Update cart items count in cart drawer header
      headerCartHeaderItemsCountelement.innerHTML = jsShoppingCart.item_count;

      // Update cart items count in drawer
      drawerCartItemsCountElement.innerHTML = jsShoppingCart.item_count;

      // Show updated cart for a few seconds
      addedToCartMessageElement.classList.add("success");
      setTimeout(() => {
        // Hide updated cart again
        addedToCartMessageElement.classList.remove("success");
      }, 5000);
    } catch (err) {
      //console.log(err);
    }
    addToCartButton.removeAttribute("disabled");
  });

  function updateCart(cart, product) {
    if (cart.items.length === 0) {
      cart.items = [...cart.items, product];
    } else {
      let item_index = cart.items.findIndex(
        (item) => item.variant_id === product.variant_id
      );
      if (item_index < 0) {
        cart.items.unshift(product);
      } else {
        cart.items[item_index] = product;
      }
    }

    // Add number of products in cart
    cart.item_count = cart.items.reduce((adding, item) => {
      return adding + item.quantity;
    }, 0);
  }

  function redrawCart(cart) {
    let cartContent = "";
    cart.items.forEach((item, index) => {
      cartSubtotal = cartSubtotal + item.quantity * item.price;

      cartContent += `
        <li class="pt-2 md:px-4 border-green-lighter border-b-2 flex" data-line-item-key="${
          item.key
        }">
          <a href="${item.url}">
            <img
              class="w-20 h-20"
              src="${item.featured_image.url}"
              alt="${item.featured_image.alt}"
              height="100"
              width="100"
              loading="lazy"
            />
          </a>
          <div class="pl-2 pt-2 pb-4 flex flex-col justify-between w-full">
            <a href="${item.url}">
              <p class="mb-0">
                <span class="block text-sm leading-none font-medium">${
                  item.product_title
                }<span class="tdf-cart-item-t"></span></span>
                <small class="text-xs leading-none">(${
                  item.variant_title
                })</small>
              </p>
            </a>

            <div class="flex justify-between items-center text-sm">
              <a href="${item.url}">
                <span class="block font-medium">${
                  item.quantity > 1 ? `${item.quantity} x` : ``
                } ${(item.price / 100).toFixed(0)} kr</span>
              </a>
              <div class="quantitySelector flex shadow-2xl rounded-md hidden">
                <label class="sr-only" for="Quantity">Antall</label>
                <button
                  class="oneLess"
                  type="button"
                  class="p-1 h-8 w-8 flex bg-white text-green-dark items-center justify-center shadow-none"
                >
                  <svg
                    class="w-4 h-4"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 12H6"></path>
                  </svg>
                </button>
                <div class="quantity bg-white">
                  <input
                    type="number"
                    name="quantity"
                    value="${item.quantity}"
                    min="1"
                    class="h-full w-8 bg-white text-sm text-center"
                  >
                </div>
                <button
                  class="oneMore"
                  type="button"
                  class="p-1 h-8 w-8 flex bg-white text-green-dark items-center justify-center shadow-none"
                >
                  <svg
                    class="h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </li>
      `;
    });

    // Empty the cart items and replace with ...
    headerCartItemsContainer.innerHTML = "";
    headerCartItemsContainer.insertAdjacentHTML("afterbegin", cartContent);

    // Update free shipping text
    freeFreight = cartSubtotal / 100 > freeFreightPrice;
    let almostFreeShipping = (freeFreightPrice - cartSubtotal / 100).toFixed(0);
    hasFreeShippingElement.innerHTML = freeFreight
      ? "Du har gratis frakt"
      : almostFreeShipping + " kr igjen til gratis frakt ";
  }
})();
